import React from 'react';
import style from './checkbox.module.scss';

const Checkbox = ({ label, value, onChange, labelCustomClass, isChecked, ...props }) => (
	<label className={style.label}>
		<input
			className={style.input}
			type="checkbox"
			value={value}
			checked={isChecked}
			onChange={event => onChange?.(event.target.checked)}
			{...props} />
		{label && <span className={labelCustomClass}>{label}</span>}
	</label>
);

export default Checkbox;
